'use client';
import { createAnalyticsContext } from '@s7/base';

const CLICK_CTA_EVENT = 'click_cta';
const topics = {
    header: [
        {
            step: 'header'
        },
        {
            goMain: ()=>[
                    CLICK_CTA_EVENT,
                    {
                        result: 'go_to_main'
                    }
                ],
            chooseLang: (lang)=>[
                    CLICK_CTA_EVENT,
                    {
                        result: 'choose_lang',
                        item_name: lang
                    }
                ],
            goChooseLang: ()=>[
                    CLICK_CTA_EVENT,
                    {
                        result: 'go_to_choose_lang'
                    }
                ],
            goChat: ()=>[
                    CLICK_CTA_EVENT,
                    {
                        result: 'go_to_chat'
                    }
                ],
            goProfile: ()=>[
                    CLICK_CTA_EVENT,
                    {
                        result: 'go_to_profile'
                    }
                ],
            goLogin: ()=>[
                    CLICK_CTA_EVENT,
                    {
                        result: 'go_to_login'
                    }
                ],
            goReturnPage: ()=>[
                    CLICK_CTA_EVENT,
                    {
                        result: 'go_to_return_page'
                    }
                ]
        }
    ]
};
const [AnalyticsProvider, useAnalytics] = createAnalyticsContext(topics);

export { AnalyticsProvider, useAnalytics };
//# sourceMappingURL=analytics.js.map
